import { getConfig } from './config';

export const scrollToTargetAdjusted = (targetId) => {
    const config = getConfig();
    const element = document.getElementById(targetId);
    // console.log('element', element);
    if (!element) return;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition =
        elementPosition - config?.scrollToTargetAdjustedValue || 80; //set this dynamically
    // console.log(elementPosition, offsetPosition, 'xyz');
    window.scrollBy({
        top: offsetPosition,
        behavior: 'smooth'
    });
};

export const isInWebView = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    // iOS WebView: iPhone/iPad but not Safari
    const iOSWebView = /iPhone|iPod|iPad/i.test(ua) && !/Safari/i.test(ua);

    // Android WebView: Android with "wv" in UA
    const androidWebView = /Android/i.test(ua) && /\bwv\b/.test(ua);

    return iOSWebView || androidWebView;
};
